import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "attachment" }
const _hoisted_2 = ["href"]

import {computed} from 'vue';
import {__} from "~/ts/library/Translate";
import OnlineMessageFileContentDescription from "~/core-ui/vue/chat/content/OnlineMessageFileContentDescription.vue";


const __default__ = {
    name: "OnlineMessageKnowledgeBaseArticleContent"
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    article: {}
  },
  setup(__props: any) {

let props = __props;

let attachment = computed<OperatorApplicationApi.OnlineMessageAttachmentOpenApiModel>(() => {
    return {
        url: props.article.url ? props.article.url : "about:blank",
        fileName: props.article.descr,
        fileSize: 0,
        id: null,
        type: {
            id: null,
            icon: "file-alt",
            descr: typeDescr.value
        }
    }
});

let typeDescr = computed(() => {
    return props.article.url ? (props.article.groupId ? __("Группа статей в базе знаний") : __("Статья в базе знаний")) : "Статья не найдена";
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("a", {
      href: _unref(attachment).url,
      target: "_blank"
    }, [
      _createVNode(OnlineMessageFileContentDescription, { attachment: _unref(attachment) }, {
        size: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(typeDescr)), 1)
        ]),
        _: 1
      }, 8, ["attachment"])
    ], 8, _hoisted_2)
  ]))
}
}

})